<div class="page-content container">
  <div class="page-header">
    <h1>{{ translationManager.getTranslation('bob_label_633ec5a0b1258b876ce13833') }}{{customHeaderText}}</h1>
  </div>
  <div class="page-data shadow-sm">
    <div class="page-part">
      <div class="alert alert-info"><span><i class="fa fa-info-circle"></i>{{
          translationManager.getTranslation('Страница за приказ набавки') }}</span>
      </div>
    </div>
    <div class="page-part" *ngIf="auth.isAuthorized('C1FCB642-9D20-4538-AB51-059562731B4F')">
      <div class="page-actions">
        <button class="btn btn-success" (click)="routerNavigateToCreate()"><i class="fa fa-plus mr-1"></i> {{
          translationManager.getTranslation('Додати нови') }}</button>
      </div>
    </div>
    <div class="app-table-panel" app-table>
      <div class="app-table-used-filters">
        <div class="app-table-used-filters-title">
          <span>{{ translationManager.getTranslation('Искоришћени филтери') }}</span>
        </div>
        <div class="app-table-used-filter-items" search-tags>
          <div class="app-table-used-filter-items-no-content" search-tag-no-content>
            <span>{{ translationManager.getTranslation('Без искоришћених филтера') }}</span>
          </div>
          <div class="app-table-used-filter-item" style="display: none" search-tag-prototype><span><i
                search-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                search-tag-prototype-value></i></span><a href="javascript:;"
              [title]="translationManager.getTranslation('Обрисати филтер')" search-tag-prototype-close><i
                class="fas fa-times"></i></a>
          </div>
          <div class="app-table-used-filter-item app-table-used-filter-item-order" style="display: none"
            order-tag-prototype><span><i order-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                order-tag-prototype-value></i></span><a href="javascript:;"
              [title]="translationManager.getTranslation('Обрисати филтер')" order-tag-prototype-close><i
                class="fas fa-times"></i></a>
          </div>
          <div class="app-table-used-filter-items" search-tags>
            <div class="app-table-used-filter-item" search-tag-special-content>
              <span>{{translationManager.getTranslation('Поништи филтере') }}</span>
              <a href="javascript:;" [title]="translationManager.getTranslation('Поништи филтере претраге')"
                reset-search-manually>
                <i class="fas fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="app-table-filter-panel" filter>
        <div class="app-table-filter-icon"><a href="javascript:;"
            [title]="translationManager.getTranslation('Филтрирај ентитете')" filter-open><i
              class="fas fa-filter"></i></a></div>
        <div class="app-table-filter">
          <div class="app-table-filter-search">
            <div class="app-table-filter-title"><span>{{ translationManager.getTranslation('Филтери') }}</span><a
                href="javascript:;" [title]="translationManager.getTranslation('Затвори филтер')" filter-close><i
                  class="fas fa-times"></i></a></div>
            <div class="page-part">
              <div class="alert alert-info"><span><i class="fa fa-info-circle"></i>{{
                  translationManager.getTranslation('Доступни филтери за процес филтрирања података') }}</span>
              </div>
            </div>

            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('Број захтева')}}</label>
                <div class="app-form-element-content">
                  <input type="number" search-input search-entity="RequestId"
                    [search-title-new]="translationManager.getTranslation('Број захтева')" search-action="equals">
                </div>
              </div>
            </div>

            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_633ec5c0b1258b876ce13839')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="RequestName"
                    [search-title-new]="translationManager.getTranslation('att_label_633ec5c0b1258b876ce13839')"
                    search-action="contains">
                </div>
              </div>
            </div>

            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_633ec5e7b1258b876ce1383a')}}</label>
                <div class="app-form-element-content">
                  <input type="date" search-input search-entity="DeadlineForCompletion"
                    [search-title-new]="translationManager.getTranslation('att_label_633ec5e7b1258b876ce1383a')"
                    search-action="less-than-or-equal">
                </div>
              </div>
            </div>

            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_633ec5eab1258b876ce1383b')}}</label>
                <div class="app-form-element-content">
                  <input type="date" search-input search-entity="DeadlineForEvaluation"
                    [search-title-new]="translationManager.getTranslation('att_label_633ec5eab1258b876ce1383b')"
                    search-action="less-than-or-equal">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_6343cb013eb5e395d849b6ce')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="RequestRoundStatusName"
                    [search-title-new]="translationManager.getTranslation('att_label_6343cb013eb5e395d849b6ce')"
                    search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part" hidden>
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_6343cb013eb5e395d849b6ce')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="RequestRoundStatusUniqueIdentifier"
                    [search-title-new]="translationManager.getTranslation('att_label_6343cb013eb5e395d849b6ce')"
                    search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('Аукција')}}</label>
                <div class="app-form-element-content">

                  <select search-input search-entity="IsAuction"
                    [search-title-new]="translationManager.getTranslation('Аукција')" search-action="equals">
                    <option></option>
                    <option value=1>{{translationManager.getTranslation('Да')}}</option>
                    <option value=0>{{translationManager.getTranslation('Не')}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="app-form-element-buttons">
              <button class="btn btn-success" do-search><i class="fa fa-check mr-2"></i>{{
                translationManager.getTranslation('Филтрирај') }}</button>
              <button class="btn btn-danger" reset-search><i class="fa fa-times mr-2"></i>{{
                translationManager.getTranslation('Поништи') }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="app-table">
        <table class="table table-striped text-dark-m1">
          <thead>
            <tr class="bgc-primary-tp2 text-white">

              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање')" order
                  order-entity="RequestId">
                  {{translationManager.getTranslation('Број захтева')}}
                </a>
              </th>

              <th [style]="{width: '40%'}">
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање')" order
                  order-entity="RequestName">
                  {{translationManager.getTranslation('att_label_633ec5c0b1258b876ce13839')}}
                </a>
              </th>

              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="DeadlineForCompletion">
                  {{translationManager.getTranslation('att_label_633ec5e7b1258b876ce1383a')}}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="DeadlineForEvaluation">
                  {{translationManager.getTranslation('att_label_633ec5eab1258b876ce1383b')}}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="RequestRoundStatusName">
                  {{translationManager.getTranslation('att_label_6343cb013eb5e395d849b6ce')}}
                </a>
              </th>

              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="IsAuction">
                  {{translationManager.getTranslation('Аукција')}}
                </a>
              </th>

              <th style="width: 100px" class="right">{{ translationManager.getTranslation('Акције') }}</th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr *ngFor="let item of items" [style.background-color]="isColored(item) ? '#e6ffec' : ''"
            [style.font-weight]="isColored(item) ? 'bold' : ''"> -->
            <!-- <tr *ngFor="let item of items" [style.color]="tableRowColored(item)"
            [style.font-weight]="isColored(item) ? 'bold' : ''"> -->

            <tr *ngFor="let item of items" [style.color]="tableRowColored(item)"
              [style.font-weight]="isColored(item) ? 'bold' : ''">
              <td>{{item.requestId}}</td>
              <td>{{item.requestName}}</td>
              <td>{{item.requestDeadline| date: "dd.MM.yyyy."}}</td>
              <td>{{item.requestSupplierDeadline| date: "dd.MM.yyyy."}}</td>
              <td>{{item.requestRoundStatusName}}</td>
              <td>{{item.isAuction ? translationManager.getTranslation('Да') : translationManager.getTranslation('Не')}}
              </td>

              <td class="right">
                <div class="table-actions">

                  <a *ngIf="item.requestRoundSupplierStatusUniqueIdentifier != 'AttendanceCancelled'"
                    [routerLink]="['./details', item.requestRoundSupplierId]"
                    [title]="translationManager.getTranslation('Детаљи')">
                    <i class="far fa-file"></i>
                  </a>

                  <a *ngIf="(item.requestRoundStatusUniqueIdentifier === 'Initiated' || item.requestRoundStatusUniqueIdentifier === 'SupplierSelected') &&
                            (
                              item.requestRoundSupplierStatusUniqueIdentifier === 'AttendanceRequested' ||
                              item.requestRoundSupplierStatusUniqueIdentifier === 'AttendanceConfirmed' ||
                              item.requestRoundSupplierStatusUniqueIdentifier === 'OfferSubmitted'
                            )
                            " [routerLink]="['../supplier-offers', item.requestRoundSupplierId]"
                    [title]="translationManager.getTranslation('Понуде')">
                    <i class="fa fa-list-dots"></i>
                  </a>

                  <a *ngIf="item.requestRoundStatusUniqueIdentifier === 'Initiated' &&
                            item.requestRoundSupplierStatusUniqueIdentifier === 'AttendanceRequested'"
                    href="javascript:;" (click)="showParticipateModalFor(item.requestRoundSupplierId, true)"
                    class="green" [title]="translationManager.getTranslation('Потврди учешће')">
                    <i class="fa fa-check"></i>
                  </a>

                  <a *ngIf="item.requestRoundStatusUniqueIdentifier === 'Initiated' &&
                      item.requestRoundSupplierStatusUniqueIdentifier === 'AttendanceRequested'" href="javascript:;"
                    (click)="showParticipateModalFor(item.requestRoundSupplierId, false)" class="red"
                    [title]="translationManager.getTranslation('Откажи учешће')">
                    <i class="fa fa-close"></i>
                  </a>

                  <a *ngIf="item.requestRoundStatusUniqueIdentifier === 'SupplierSelected'"
                    [routerLink]="['./confirmed-procurements', item.requestRoundSupplierId]"
                    [title]="translationManager.getTranslation('Потврђене набавке')">
                    <i class="fas fa-box"></i>
                  </a>

                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="no-content" *ngIf="!items || items.length == 0">
          <span>{{ translationManager.getTranslation('Без података') }}</span>
        </div>
      </div>
      <div class="app-table-pagination">
        <div>
          <div pagination><span>{{ translationManager.getTranslation('Страна') }}</span>
            <select pagination-pages>
              <option>1</option>
            </select>
            <span>{{ translationManager.getTranslation('од') }}</span><span pagination-pages-count>-</span>
            <span class="app-table-pagination-arrows"><a href="javascript:;"
                [title]="translationManager.getTranslation('Иди на почетак')" pagination-first-page><i
                  class="fas fa-angle-double-left"></i></a><a href="javascript:;"
                [title]="translationManager.getTranslation('Претходна')" pagination-previous-page><i
                  class="fas fa-angle-left"></i></a></span><span class="app-table-pagination-arrows"><a
                href="javascript:;" [title]="translationManager.getTranslation('Следећа')" pagination-next-page><i
                  class="fas fa-angle-right"></i></a><a href="javascript:;"
                [title]="translationManager.getTranslation('Иди на крај')" pagination-last-page><i
                  class="fas fa-angle-double-right"></i></a></span>
            <span>{{ translationManager.getTranslation('Број редова за приказ') }}</span>
            <select pagination-sizes>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
        <div class="app-table-pagination-sizes">
          <div><span>{{ translationManager.getTranslation('Укупан број слогова') }}</span><span
              pagination-total-count>-</span></div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-modal [show]="showDeleteModal" (onHide)="showDeleteModal = false"
  [title]="translationManager.getTranslation('Брисање')">
  <div class="app-modal-content">
    <label>{{ translationManager.getTranslation('Да ли сте сигурни да желите да обришете набавку?') }}</label>
  </div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="delete()"><i class="fa fa-check mr-2"></i>{{
      translationManager.getTranslation('Да') }}</button>
    <button (click)="showDeleteModal = false" class="btn btn-warning"><i class="fa fa-times mr-2"></i>{{
      translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>

<app-modal [show]="displayParticipateModal" (onHide)="displayParticipateModal = false">
  <div class="app-modal-content">
    <label>{{ participateQuestion }}</label>
  </div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="partcipate()"><i class="fa fa-check mr-2"></i>{{
      translationManager.getTranslation('Да') }}</button>
    <button (click)="displayParticipateModal = false" class="btn btn-warning"><i class="fa fa-times mr-2"></i>{{
      translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>
